<template lang='pug'>
  #portfolio.view 
    .side-nav.centered-text
      .logo
      digi-divider.section.borderless
      .excerpt
        span Some description text here. adsdda adad aadada ad asdasd adsaasd
      digi-divider.card.on-dark
      .team 
        span Team Members
      digi-divider.card.on-dark
      .contact(@click='contact = true')
        span Contact Us
    main
      .project(v-for='project in projects')
        h1 {{ project.title }}
        digi-flex.column
          .image
            img(
              :src='project.main'
              @click='picture = project.main'
            )
          digi-divider.card.borderless
          agile.carousel(:options='myOptions' :infinite='false')
            .items-container(v-for='thumb in project.thumbs')
              img(
                @click='picture = thumb'
                :src='thumb'
              )
            template(slot='prevButton')
              left-icon.previous
            template(slot='nextButton')
              right-icon.next
          //- digi-grid.thumbs
            img(
              v-for='thumb in project.thumbs'
              @click='picture = thumb'
              :src='thumb'
            )
        p.button.centered-text(@click='project.show = true' v-if='!project.show') More
        .info(v-if='project.show')
          h1 Title: {{ project.title }} 
          p Build: {{ project.build}}
          p Duration: {{ project.duration }}
          p Description: {{ project.description }}
        p.button.centered-text(@click='project.show = false' v-if='project.show') Less
      
      digi-flex.picture.centered(
        v-if='picture'
        @click.native='picture = ""'
      )
        .pic.container
          img(:src='picture')
          .close(@click='picture = ""')
            close-icon

      digi-flex.centered.contact(v-if='contact' @click.native='contact = false')
        .contact-container
          digi-flex.container
            base-card.container(@click.native.stop)
              h1.centered-text Contact Form
              form
                digi-input.basic
                  input(type='email' placeholder='Your Email')
                digi-input.basic
                  textarea(type='text' placeholder='Your Query')
                digi-divider.card.borderless
                digi-button.text-only.centered(@click='submit')
                  template(v-slot:text) 
                    span Send
              .close(@click='contact = false')
                close-icon
            .orange
            .gray
            .svg
              img(src='/mailsent.svg')
            
            

</template>

<script>
export default {
  name: 'portfolio.view',

  data() {
    return {
      projects: {
        diginomix: {
          thumbs: [
            '/results.jpg',
            '/resultsmbl.jpg',
            '/results.jpg',
            '/resultsmbl.jpg'
          ],
          main: '/results.jpg',
          title: 'Diginomix',
          build: 'Vue',
          duration: '2 Months',
          description: 'Lorem Ipsum adas asdasd asdasd asd asdadsa asdas dasd asda sd asdasda sad asdasdasd aasdasdas sadasdasdasd asdasdasdasd asdasdasd asdasad',
          show: false
        },

        second: {
          thumbs: [
            '/results.jpg',
            '/resultsmbl.jpg',
            '/results.jpg',
            '/resultsmbl.jpg'
          ],
          main: '/results.jpg',
          title: 'Second',
          build: 'Vue',
          duration: '9 Weeks',
          show: false
        }
      },

      show: {},
      picture: '',
      contact: false,
      myOptions: {
        infinite: false,
        // navButtons: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 5,
              navButtons: true
            }
          },

          {
            breakpoint: 820,
            settings: {
              slidesToShow: 4,
              navButtons: true
            }
          },

          {
            breakpoint: 580,
            settings: {
              slidesToShow: 3,
              navButtons: true
            }
          },

          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              navButtons: true
            }
          },

          {
            breakpoint: 380,
            settings: {
              slidesToShow: 2.2,
              navButtons: false
            }
          },

          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1.6,
              navButtons: false
            }
          },
        ]
      },
    }
  }
}
</script>

<style scoped lang='stylus'>
  .side-nav 
    width 200px
    background rgba( 220 220 220 .1 )
    height 100vh
    padding 24px 20px
    box-sizing border-box
    position fixed
    top 0
    left 0
    .logo 
      height 160px
      width 160px
      border 1px solid black
      margin 0 auto
    .excerpt
      //
    .contact, .team
      color white
      cursor pointer
      &:hover 
        color rgb( 220 220 220 )
        transform scale(1.01)
        transition all 200ms
        
  main 
    margin-left 200px
    padding 24px
    .project
      background rgba( 200 200 200 .3 )
      margin-bottom 64px
      padding 16px 12px 0 12px
      border-radius 9px
      h1 
        color white
        font-size 2em
        text-decoration underline
      .digi-flex
        @media(max-width: 860px)
          flex-direction column
          overflow hidden
        .image
          height 300px
          width 50%
          background red
          margin-right 12px
          @media(max-width: 860px)
            margin-right 0
            margin-bottom 16px
        .carousel
          padding 0 24px
          >>> button
            padding 0
            border 0
          .items-container 
            padding 8px 24px
            box-sizing border-box
            img  
              height 100%
              width 100%
              object-fit contain
          
          .previous, .next
            position absolute 
            top 0
            bottom 40px
            margin auto 0
            font-size 8em
            color rgb( 160 160 160 )
            cursor pointer
            color white
          .previous
            left -38px
            @media(max-width: 1200px)
              left -50px
            @media(max-width: 1080px)
              left -60px
          .next
            right -38px
            @media(max-width: 1200px)
              right -50px
            @media(max-width: 1080px)
              right -60px
        // .thumbs 
        //   grid-template-columns repeat(auto-fill, minmax(280px, 1fr) )
        //   // grid-template-columns 1fr 1fr
        //   grid-template-rows 1fr 1fr
        //   height 300px
        //   width 100%
        //   grid-gap 1vh 1vw
        //   overflow visible
        //   @media(max-width: 13000px)
        //     grid-template-columns repeat(auto-fill, minmax(180px, 1fr) )
        .image, .thumbs
          img 
            height 100%
            width 100%
            object-fit cover
            cursor pointer
            &:hover 
              transform scale(1.007)
              transition all 500ms
      .button 
        color white
      .info 
        margin-top 24px
        p 
          padding 0
          color white
    
    .picture 
      .pic 
        padding 48px
        background rgba( 220 220 220 .8 )
        border-radius 9px
        img 
          box-shadow var(--box-shadow)
        .close 
          position absolute
          top 4px
          right 12px
          font-size 2em
          color gray

    .picture, .contact 
      position fixed
      top 0
      left 0
      right 0
      bottom 0

    .contact
      .base-card 
        padding 36px
        background rgba( 220 220 220 .9 )
        z-index 2
        box-sizing border-box
        box-shadow var(--box-shadow-shallow)
        .digi-input
          input, textarea
            outline 0
            border 0
            border-radius 5px
            width 320px
            background rgb( 240 240 240 )
            &:focus
              outline 0
              border 0
            &::placeholder 
              color rgb( 240 128 80 )
            @media(max-width: 480px)
              width 60vw
        .digi-button 
          margin 0 auto
          border-radius 9px
          &:hover 
            background rgb( 240 128 80 )
            color white
            transition all 300ms
        .close 
          position absolute 
          top 12px
          right 18px
          font-size 2em
          color rgb( 120 120 120 )
      .svg 
        height 480px
        position absolute
        z-index 1
        top -130px
        right -280px
        @media(max-width: 800px)
          height 380px
          right -120px
        @media(max-width: 580px)
          display none
        img
          height 100%
          width 100%
          object-fit contain
      .orange, .gray
        height 360px
        width 240px
        position absolute 
        z-index 0
        left -40px
        top -28px
        border-radius 9px
        @media(max-width: 800px)
          height 320px
          width 180px
          left 10px
        @media(max-width: 580px)
          display none
      .orange
        transform rotate(-15deg)
        background rgb( 240 128 80 )
      .gray 
        transform translateX(-38px) rotate(-25deg) 
        background rgba( 210 210 210 .9 )
</style>